import { useMemo } from "react";
import { SystemConstant } from "const";
import useTotalUserList from "./useTotalUserList";
import { CommonUtils } from "utils";
import { selectAllUnitValue } from "pages/CompanyManagement/components/AddMemberDialog";

export default function useUnitUserList(unitId, searchValue = "", page = SystemConstant.ACTIVE_PAGINATION) {
  const { totalUsers } = useTotalUserList();

  const isMatchingUnit = (user, targetUnitId) => {
    if (!targetUnitId || targetUnitId === selectAllUnitValue) return true;
    return String(user.unitId) === String(targetUnitId);
  };

  const unitUserList = useMemo(() => {
    return totalUsers
      .filter(user => isStateCondition(user) && (unitId && unitId !== selectAllUnitValue ? String(user.unitId) === String(unitId) : true))
      .map(user => ({ label: user.name, id: user.accountId }));
  }, [totalUsers, unitId]);

  const query = (searchValue || "").trim().toLowerCase();
  const queryWithoutVN = CommonUtils.removeVietnameseTones(query);
  const queryPhone = query.replace("+84", "0");

  const unitUserListFilter = useMemo(() => {
    return totalUsers
      .filter(user => {
        if (!isStateCondition(user) || !isMatchingUnit(user, unitId)) return false;
        if (!query) return true;
        const name = CommonUtils.removeVietnameseTones((user.name || "").toLowerCase());
        const mail = (user.mail || "").toLowerCase();
        const phone = user.phone || "";
        const phoneWithoutVN = phone.replace("+84", "0");
        return (
          name.includes(queryWithoutVN) ||
          mail.includes(query) ||
          phone.includes(query) ||
          phoneWithoutVN.includes(queryPhone)
        );
      })
      .map(user => ({
        id: user.accountId,
        name: user.name,
        mail: user.mail,
        phone: user.phone,
        unit: user.unitName,
        department: user.departmentName,
      }));
  }, [totalUsers, unitId, query]);

  const totalPages = Math.ceil(unitUserListFilter.length / SystemConstant.USERS_LIMITED_NUMBER) || 1;

  const currentPageUsers = useMemo(() => {
    return CommonUtils.paginateFromArray(
      unitUserListFilter,
      page,
      SystemConstant.USERS_LIMITED_NUMBER,
    );
  }, [unitUserListFilter, page]);

  return {
    unitUserList,
    totalPages,
    currentPageUsers,
  };
}

const isStateCondition = user => {
  let stateCondition = false;
  if (user.state !== 0 && user.state !== 2 && user.branchAccountState !== 0 && user.branchAccountState !== 2) {
    stateCondition = true;
  }
  return stateCondition;
};

